module.exports = __webpack_public_path__ + "static/images/grabpay.2-DGsOu.svg";